import FullScreenLoader from 'components/FullScreenLoader';

interface Properties {
  isGridElement?: boolean;
}

/**
 * Viewport-height variant. Delegates rather than keeping its own copy of the
 * markup: the duplicate still carried the pre-revamp violet background long
 * after the shared loader moved off it.
 */
const FullScreenLoad = ({ isGridElement }: Properties) => (
  <FullScreenLoader isGridElement={isGridElement} height='100vh' />
);

export default FullScreenLoad;
